import React from "react";
import SectionTitle from "../SectionTitle/SectionTitle";
import "@justinribeiro/lite-youtube";


const VideoSection = (props) => {
    const { title, subtitle } = props;
    return (
      <section>
        <div className="container mt-5">
          <div className="row justify-content-center">
            <div className="col-lg-9 col-12">
              <SectionTitle title={title} subtitle={subtitle} />
            </div>
          </div>
          <div className="movie_wrap">
            <lite-youtube
              wrapperClass="yt-lite"
              videoid="GODNLrW-ddA"
            ></lite-youtube>
          </div>
        </div>
      </section>
    );
}

export default VideoSection;




